import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueObserveVisibility from 'vue-observe-visibility'
// import Firebase from 'firebase/database/dist/database/index.d.ts'
// import Firebase from 'firebase/firebase-database.js
import firebase from 'firebase/compat';
// import Firebase from 'firebase'
import vb from 'vue-babylonjs';
import vuetify from './plugins/vuetify';
import VueFacebookPixel from 'vue-analytics-facebook-pixel';
import VueAnalytics from 'vue-analytics';
import VueYoutube from 'vue-youtube'

const isProd = process.env.NODE_ENV == 'production'

Vue.use(VueYoutube)
Vue.use(vb);
Vue.use(VueFacebookPixel)
Vue.analytics.fbq.init('891406877963228', {
  em: 'juliankodlin@yahoo.de'
})

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-219062231-1',
  ecommerce: {
    enabled: true
  },
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  },
  router
});



Vue.use(VueObserveVisibility)

var width = window.innerWidth;
var height = window.innerHeight;

var smalerDimension = 0;

if (width > height){
  smalerDimension = height;
} else {
  smalerDimension = width;
}

var squarePictureMaxDimension = smalerDimension
document.documentElement.style.setProperty('--squarePictureMaxDimension', `${squarePictureMaxDimension}px`);

var desktopNavigationHeight = 70
document.documentElement.style.setProperty('--desktopNavigationHeight', `${desktopNavigationHeight}px`);

var widthCenterElement = 600
document.documentElement.style.setProperty('--widthCenterElement', `${widthCenterElement}px`);

var widthSidesBigCenterElement = 100
document.documentElement.style.setProperty('--widthSidesBigCenterElement', `${widthSidesBigCenterElement}px`);

var widthInsideLeftRightElement = 400
document.documentElement.style.setProperty('--widthInsideLeftRightElement', `${widthInsideLeftRightElement}px`);

var configuratorDesktopWidthOfSelector = 360
document.documentElement.style.setProperty('--configuratorDesktopWidthOfSelector', `${configuratorDesktopWidthOfSelector}px`);

var accentColor = "#E38A64"
document.documentElement.style.setProperty('--accentColor', `${accentColor}`);

var accentColorShaded = "#FFCFBE"
document.documentElement.style.setProperty('--accentColorShaded', `${accentColorShaded}`);

var accentColorShadedComplementary = '#D0F2D6'
document.documentElement.style.setProperty('--accentColorShadedComplementary', `${accentColorShadedComplementary}`);

var accentColorShadedTransparent = "#FFCFBEB0"
document.documentElement.style.setProperty('--accentColorShadedTransparent', `${accentColorShadedTransparent}`);

var mainColor = "#003157"
document.documentElement.style.setProperty('--mainColor', `${mainColor}`);

var mainColorShaded = "#d3e0e1"
document.documentElement.style.setProperty('--mainColorShaded', `${mainColorShaded}`);

const firebaseConfig = {
  apiKey: "AIzaSyAqmjmaqv3Wzxn0aIx_v0R-dTFTyNlJ_pY",
  authDomain: "furnitures-7a3b4.firebaseapp.com",
  databaseURL: "https://furnitures-7a3b4.firebaseio.com",
  projectId: "furnitures-7a3b4",
  storageBucket: "furnitures-7a3b4.appspot.com",
  messagingSenderId: "955593757319",
  appId: "1:955593757319:web:f760c0e5e35abb9c8dde22"
}
firebase.initializeApp(firebaseConfig)
export const db = firebase.database()

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
